import { useContext, useEffect, useRef, useState } from 'react'
import Navbar from '../navbar/Navbar'
import Sidebar from '../sidebar/Sidebar'
import Employee from './Employee'
import { collection, getDocs, limit, orderBy, query, where } from 'firebase/firestore'
import { db } from '../../firebase'
import { AuthContext } from '../../authContext/AuthContext'
import GraphBadPieces from '../graph/GraphBadPieces'
import { getBadPercent } from '../../utils/getBadPercent'
import { BiFilter } from 'react-icons/bi'
import GraphProductedPieces from '../graph/GraphProductedPieces'
import { getProductedPieces } from '../../utils/getProductedPieces'
import GraphCompletedJobCards from '../graph/GraphCompletedJobCards'
import { getCompletedJobCards } from '../../utils/getCompletedJobCards'
import { toast, ToastContainer } from "react-toastify"

const Dashboard = () => {
  const { currentUser } = useContext(AuthContext)
  const [badPercent, setBadPercent] = useState({})
  const [employees, setEmployees] = useState([1, 2, 3, 4])
  const [showGraphBadPieces, setShowGraphBadPieces] = useState(false)
  const [showGraphProductedPieces, setShowGraphProductedPieces] = useState(false)
  const [productedQuantity, setProductedQuantity] = useState({})
  const [completedJobCards, setCompletedJobCards] = useState({})
  const [badPiecesDate, setBadPiecesDate] = useState('')
  const [productedPiecesDate, setProductedPiecesDate] = useState('')
  const [completedJobCardsDate, setCompletedJobCardsDate] = useState('')
  const [showCompletedJobCardsMenu, setShowCompletedJobCardsMenu] = useState(false)
  const [badPiecesLoading, setBadPiecesLoading] = useState(false)
  const [productedPiecesLoading, setProductedPiecesLoading] = useState(false)
  const badPiecesMenu = useRef(null)
  const productedPiecesMenu = useRef(null)
  const completedJobCardsMenu = useRef(null)


  useEffect(() => {
    const getBadPiecesStats = async () => {
      setBadPiecesLoading(true)
      var endDate = new Date();
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 8)

      const q = query(collection(db, "machine_job_stats"),
        where('timestamp', '>=', badPiecesDate !== '' ? new Date(new Date(badPiecesDate).setDate(new Date(badPiecesDate).getDate() - 8)) : startDate),
        where('timestamp', '<=', (badPiecesDate !== '' ? new Date(new Date(badPiecesDate).setDate(new Date(badPiecesDate).getDate() + 1)) : endDate)))

      const stats_Snap = await getDocs(q);
      if (!stats_Snap.empty) {
        let data = [];
        stats_Snap.forEach((doc) => {
          data.push({ ...doc.data(), id: doc.id, day: doc.data().timestamp.toDate().getDate() })
        })
        setBadPercent(getBadPercent(data))
      }else{
        toast.error('No results found related to given date.')
      }
      setBadPiecesLoading(false)
    }
    getBadPiecesStats()
  }, [badPiecesDate])

  useEffect(() => {
    const getProductedPiecesStats = async () => {
      setProductedPiecesLoading(true)
      var endDate = new Date();
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 8)

      const q = query(collection(db, "machine_job_stats"),
        where('timestamp', '>=', productedPiecesDate !== '' ? new Date(new Date(productedPiecesDate).setDate(new Date(productedPiecesDate).getDate() - 8)) : startDate),
        where('timestamp', '<=', (productedPiecesDate !== '' ? new Date(new Date(productedPiecesDate).setDate(new Date(productedPiecesDate).getDate() + 1)) : endDate)))

      const stats_Snap = await getDocs(q);
      if (!stats_Snap.empty) {
        let data = [];
        stats_Snap.forEach((doc) => {
          data.push({ ...doc.data(), id: doc.id, day: doc.data().timestamp.toDate().getDate() })
        })
        setProductedQuantity(getProductedPieces(data))
      }else{
        toast.error('No results found related to given date.')
      }
      setProductedPiecesLoading(false)
    }
    getProductedPiecesStats()
  }, [productedPiecesDate])

  useEffect(() => {
    const fetchCompletedJobCards = async () => {
      var endDate = new Date();
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 18)

      const q = query(collection(db, "jobs"), where('completedAt', '!=', ''), 
                where('completedAt', '>=', completedJobCardsDate !== '' ? new Date(new Date(completedJobCardsDate).setDate(new Date(completedJobCardsDate).getDate() - 18)) : startDate), 
                where('completedAt', '<=', (completedJobCardsDate !== '' ? new Date(new Date(completedJobCardsDate).setDate(new Date(completedJobCardsDate).getDate() + 1)) : endDate)))

      const cards = await getDocs(q);
      if (!cards.empty) {
        let data = []
        cards.forEach((doc) => {
          data.push({ ...doc.data(), id: doc.id, day: doc.data().completedAt.toDate().getDate() })
        })
        setCompletedJobCards(getCompletedJobCards(data))
      }else{
        toast.error('No results found related to given date.')
      }
    }
    fetchCompletedJobCards()
  }, [completedJobCardsDate])


  useEffect(() => {
    async function get_Recent_Employees() {
      const q = query(collection(db, 'employees'), where('adminId', '==', currentUser.uid), orderBy("name", "desc"), limit(4));
      const querySnapshot = await getDocs(q);
      const data = []
      querySnapshot.forEach((doc) => {
        data.push({
          ...doc.data(),
          id: doc.id
        })
      });
      setEmployees(data)
    }
    get_Recent_Employees()
  }, [currentUser.uid])

  useEffect(() => {
    const closeBadPiecesMenu = (e) => {
      if (showGraphBadPieces && badPiecesMenu.current && !badPiecesMenu.current.contains(e.target)) {
        setShowGraphBadPieces(false)
      }
    }
    document.addEventListener('mousedown', closeBadPiecesMenu)
    return () => document.removeEventListener('mousedown', closeBadPiecesMenu)
  }, [showGraphBadPieces])

  useEffect(() => {
    const closeProductedPiecesMenu = (e) => {
      if (showGraphProductedPieces && productedPiecesMenu.current && !productedPiecesMenu.current.contains(e.target)) {
        setShowGraphProductedPieces(false)
      }
    }
    document.addEventListener('mousedown', closeProductedPiecesMenu)
    return () => document.removeEventListener('mousedown', closeProductedPiecesMenu)
  }, [showGraphProductedPieces])

  useEffect(() => {
    const closeCompletedJobCardsMenu = (e) => {
      if (showCompletedJobCardsMenu && completedJobCardsMenu.current && !completedJobCardsMenu.current.contains(e.target)) {
        setShowCompletedJobCardsMenu(false)
      }
    }
    document.addEventListener('mousedown', closeCompletedJobCardsMenu)
    return () => document.removeEventListener('mousedown', closeCompletedJobCardsMenu)
  }, [showCompletedJobCardsMenu])

  return (
    <div>
      <Navbar />
      <div className="flex bg-gray-50">
        <Sidebar currentPage='Dashboard' />
        <div className='lg:flex-1 w-full lg:w-auto'>

          <div className="flex mt-1 lg:mt-2 px-2 py-1 flex-col items-center md:flex-row space-x-2 space-y-1">
            <span></span>
            <div ref={badPiecesMenu} className={`relative flex min-h-[312px] bg-gradient-to-t from-gray-200 to-slate-100 flex-col box-border w-full  rounded-lg shadow-md px-1 py-2 ${badPiecesLoading && 'animate-pulse to-gray-200'}`}>
              <div onClick={() => setShowGraphBadPieces(prev => !prev)} className='absolute active:scale-90 z-20 transition-scale duration-100 -top-1 -left-1 bg-purple-500 cursor-pointer px-1 py-1 rounded-full font-medium title-font text-slate-100 shadow-md'><BiFilter className='text-2xl' /></div>
              {!badPiecesLoading && <GraphBadPieces badPercent={badPercent} />}
              <div className={`flex flex-col bg-white border z-30 border-gray-300 px-3 py-2 rounded-lg shadow-xl transition-all duration-200 scale-0 absolute left-[-80px] top-[-40px] ${showGraphBadPieces && 'scale-100 top-[29px] left-[-1px]'}`}>
                <span className='font-semibold text-base text-slate-600 pb-1 border-b border-gray-300'>Select Date</span>
                <div className="flex mb-2 flex-col">
                  <span className='text-sm text-thin my-2'>Date</span>
                  <input onChange={(e) => setBadPiecesDate(e.target.value ? (e.target.value) : '')} value={badPiecesDate} type="date" className='w-36 bg-gray-100 py-1 px-2 rounded-md shadow outline-1 outline-gray-400 focus:outline-blue-500' />
                </div>
                {badPiecesDate && <button onClick={() => setBadPiecesDate('')} className='py-1 rounded-md text-white my-1 btn-color transition-all duration-200'>Clear</button>}
              </div>
            </div>

            <div ref={productedPiecesMenu} className={`relative flex min-h-[312px] bg-gradient-to-t from-gray-200 to-slate-100 box-border flex-col w-full rounded-lg shadow-md px-2 py-2 ${productedPiecesLoading && 'animate-pulse to-gray-200'}`}>
              <div onClick={() => setShowGraphProductedPieces(prev => !prev)} className='absolute active:scale-90 z-20 transition-scale duration-100 -top-1 -left-1 bg-purple-500 cursor-pointer px-1 py-1 rounded-full font-medium title-font text-slate-100 shadow-md'><BiFilter className='text-2xl' /></div>
              {!productedPiecesLoading && <GraphProductedPieces productedQuantity={productedQuantity} />}
              <div className={`flex flex-col border border-gray-300 z-30 bg-white px-3 py-2 rounded-lg shadow-xl transition-all duration-200 scale-0 absolute left-[-80px] top-[-40px] ${showGraphProductedPieces && 'scale-100 top-[29px] left-[-1px]'}`}>
                <span className='font-semibold text-base text-slate-600 pb-1 border-b border-gray-300'>Select Date</span>
                <div className="flex flex-col mb-2">
                  <span className='text-sm my-2 text-thin'>Date</span>
                  <input type="date" value={productedPiecesDate} onChange={(e) => setProductedPiecesDate(e.target.value ? e.target.value : '')} className='bg-gray-100 w-36 py-1 px-2 rounded-md shadow' />
                </div>
                {productedPiecesDate && <button onClick={() => setProductedPiecesDate('')} className='py-1 rounded-md text-white my-1 btn-color transition-all duration-200'>Clear</button>}
              </div>
            </div>
          </div>

          <div className="flex mt-1 space-x-2 space-y-2 items-center mb-2 px-2 flex-col md:flex-row">
            <span></span>
            <div ref={completedJobCardsMenu} className="relative flex w-full flex-col pb-2 pt-5 px-1 shadow-lg bg-white rounded-md">
            <div onClick={() => setShowCompletedJobCardsMenu(prev => !prev)} className='absolute active:scale-90 z-20 transition-scale duration-100 -top-1 -left-1 bg-purple-500 cursor-pointer px-1 py-1 rounded-full font-medium title-font text-slate-100 shadow-md'><BiFilter className='text-2xl' /></div>
              <GraphCompletedJobCards completedJobCards={completedJobCards} />
              <div className={`flex flex-col border border-gray-300 z-30 bg-white px-3 py-2 rounded-lg shadow-xl transition-all duration-200 scale-0 absolute left-[-80px] top-[-40px] ${showCompletedJobCardsMenu && 'scale-100 top-[29px] left-[-1px]'}`}>
                <span className='font-semibold text-base text-slate-600 pb-1 border-b border-gray-300'>Select Date</span>
                <div className="flex flex-col mb-2">
                  <span className='text-sm my-2 text-thin'>Date</span>
                  <input type="date" value={completedJobCardsDate} onChange={(e) => setCompletedJobCardsDate(e.target.value ? e.target.value : '')} className='bg-gray-100 w-36 py-1 px-2 rounded-md shadow' />
                </div>
                {completedJobCardsDate && <button onClick={() => setCompletedJobCardsDate('')} className='py-1 rounded-md text-white my-1 btn-color transition-all duration-200'>Clear</button>}
              </div>
            </div>

            <div className="relative flex w-full flex-col pb-2 pt-5 px-1 shadow-lg bg-white rounded-md">
              <h1 className='absolute -top-3 left-0 bg-blue-200 font-medium title-font text-sm text-blue-600 px-2 sm:px-3 rounded-full py-1 shadow'>Recently Added Employees</h1>
              {employees.map((employee) => (
                <Employee key={employee.id} employee={employee} />
              ))}
            </div>
          </div>

        </div>
      </div>
      <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='light'
            />
    </div>
  )
}

export default Dashboard